import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_discount_banner~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__b'),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_discount_banner~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__c'),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_discount_banner~3
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__d'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_discount_banner~3
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_discount_banner/__d'),
			},
		},
	},
]

export default config
